<template>
  <div v-if="activeSections.length" class="dynamic-section relative">
    <div class="w-full h-3 bg-[#f2f2f2]" />

    <section v-for="(section, i) in activeSections" :key="section.id">
      <div class="p-16 flex items-center justify-between">
        <BlTextAv variation="body-16" weight="bold" tag="h2">{{ section.name }}</BlTextAv>
        <router-link v-if="section.total_items > 10" class="no-underline" :to="redirectLink(section)">
          <BlTextAv variation="caption-12" class="lihat-semua-btn text-[#2B4AC7]" weight="medium">Lihat Semua</BlTextAv>
        </router-link>
      </div>
      <div class="snap-x overflow-x-auto scroll-pl-4 w-full flex space-x-2 ph-16">
        <div
          v-for="item in displayFirstTenCourses(section.items)"
          :key="item.id"
          class="snap-start min-w-[148px] max-w-[148px] shrink-0 first:pl-6"
        >
          <PrakerjaCard
            :course="serializeItemToCourse(item)"
            :course-type="serializeItemToCourse(item).courseType"
            referrer="dynamic-section"
            class="min-w-[148px]"
          />
        </div>
      </div>
      <div v-if="i !== activeSections.length - 1" class="w-full h-3 bg-[#f2f2f2] mt-16" />
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {titleToSlug} from 'src/shared/javascripts/commons/text';
import PrakerjaCard from '../PrakerjaCard/PrakerjaCard.vue';

export default {
  name: 'PrakerjaDynamicSection',
  components: {PrakerjaCard},
  props: {
    category: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('sections', ['getSections']),
    activeSections() {
      return this.getSections?.[this.category] ?? [];
    },
  },
  created() {
    this.fetchSectionByCategory({category: this.category});
  },
  methods: {
    ...mapActions('sections', ['fetchSectionByCategory']),
    titleToSlug,
    serializeItemToCourse(item) {
      return {
        id: item.item_id,
        name: item.item_name,
        images: [{url: item.image_url}],
        discount: {original_price: item.original_price},
        rating: item.rating,
        courseType: item.course_type || '',
        prakerja_remaining_stock: item.prakerja_remaining_stock,
      };
    },
    displayFirstTenCourses(items) {
      return items.slice(0, 10);
    },
    redirectLink(section) {
      return `/section/${section.category}/${titleToSlug(section.id + '-' + section.name)}?referrer=dynamic-section`;
    },
  },
};
</script>
